import { GlIcon, GlPopover, GlBadge, GlSprintf } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '../../../alert.js?vue3';
import { s__ } from '~/locale';
import SafeHtml from '~/vue_shared/directives/safe_html';
import TimeAgoTooltip from '../../../vue_shared/components/time_ago_tooltip.vue?vue3';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import { findHierarchyWidget, formatAncestors } from '../../utils.js?vue3';
import workItemAncestorsQuery from '../../graphql/work_item_ancestors.query.graphql';
import workItemAncestorsUpdatedSubscription from '../../graphql/work_item_ancestors.subscription.graphql';
import WorkItemStateBadge from '../work_item_state_badge.vue?vue3';
import DisclosureHierarchy from './disclosure_hierarchy.vue?vue3';
export const ANCESTOR_NOT_AVAILABLE = {
    message: s__('WorkItems|Ancestors not available'),
    ancestorNotAvailable: true,
    icon: 'eye-slash'
};
export default {
    name: 'WorkItemAncestors',
    i18n: {
        ancestorLabel: s__('WorkItem|Ancestor'),
        ancestorsTooltipLabel: s__('WorkItem|Show all ancestors')
    },
    components: {
        GlIcon,
        GlPopover,
        GlBadge,
        GlSprintf,
        TimeAgoTooltip,
        WorkItemStateBadge,
        DisclosureHierarchy
    },
    directives: {
        SafeHtml
    },
    mixins: [
        glFeatureFlagsMixin()
    ],
    props: {
        workItem: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            ancestors: []
        };
    },
    apollo: {
        ancestors: {
            query: workItemAncestorsQuery,
            variables () {
                return {
                    id: this.workItem.id,
                    useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField)
                };
            },
            update (data) {
                const formattedAncestors = formatAncestors(data.workItem).flatMap((ancestor)=>{
                    const ancestorHierarchyWidget = findHierarchyWidget(ancestor);
                    // Condition is to check if it `hasParent` is true and the parent object is null  i.e, inaccessible
                    // then add "ancestor is not available" with other parents
                    return ancestorHierarchyWidget?.hasParent && !ancestorHierarchyWidget?.parent ? [
                        ANCESTOR_NOT_AVAILABLE,
                        ancestor
                    ] : [
                        ancestor
                    ];
                });
                // If the work item has a parent at root level but the parent object is null i.e, inaccessible
                // then add "ancestor is not available" as the only item
                const widgets = findHierarchyWidget(data.workItem);
                if (formattedAncestors.length === 0 && widgets?.hasParent && !widgets?.parent) {
                    formattedAncestors.push(ANCESTOR_NOT_AVAILABLE);
                }
                return formattedAncestors;
            },
            skip () {
                return !this.workItem.id;
            },
            error (error) {
                createAlert({
                    message: s__('Hierarchy|Something went wrong while fetching ancestors.'),
                    captureError: true,
                    error
                });
            },
            subscribeToMore: {
                document: workItemAncestorsUpdatedSubscription,
                variables () {
                    return {
                        id: this.workItem.id,
                        useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField)
                    };
                },
                skip () {
                    return !this.workItem?.id;
                }
            }
        }
    }
};
